/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2023-01-16 13:57:04
 * @LastEditors  : yangxr
 * @Description  : 特材运输API
 * @FilePath     : \icps_fb\src\api\wise\Wise_rentunit\Wise_rentunit4.js
 */
import request from '@/utils/request'
export const Download = '/icps/system/sign/settlement/trans/raw/detail/exportList'
/**1.待结算-获取合同列表*/
export function get_contract_list(params) {
  return request({
    url: '/icps/system/sign/settlement/trans/SpecialMaterials/detail/getContractList',
    method: 'get',
    params
  })
}
/** 2.分页获取待结算运输列表*/
export const queryPage1 = '/icps/system/sign/settlement/trans/SpecialMaterials/detail/get_no_settlement_data'
/**3.生成结算单*/
export function generate_statement(data) {
  return request({
    url: '/icps/system/sign/settlement/trans/SpecialMaterials/detail/generate_statement',
    method: 'post',
    data
  })
}

/**4.分页查询已结算信息*/
export const queryPage2 = '/icps/system/sign/settlement/trans/SpecialMaterials/detail/getStatementDetail'
/**5.修改或保存结算单*/
export function save_or_update_detail(data) {
  return request({
    url: '/icps/system/sign/settlement/trans/SpecialMaterials/detail/saveStatement',
    method: 'post',
    data
  })
}
/**6.已结算-获取查询条件*/
export function get_search_conditions() {
  return request({
    url: '/icps/system/sign/settlement/trans/raw/detail/get_search_conditions',
    method: 'get',
  })
}
/**7.结算单-获取供应商列表*/
export function get_supplier_list(data) {
  return request({
    url: '/icps/system/sign/settlement/statement/get_supplier_list',
    method: 'post',
    data
  })
}

/**8.分页查询已结算信息*/
export const queryPage3 = '/icps/system/sign/settlement/statement/get_statement_page'
/**9.分页查询已结算信息*/
export function get_statement_detail(data) {
  return request({
    url: '/icps/system/sign/settlement/trans/SpecialMaterials/detail/getStatementDetail',
    method: 'post',
    data
  })
}
/**10.修改审核状态或客户确认状态*/
export function update_status(data) {
  return request({
    url: '/icps/system/sign/settlement/statement/update_status',
    method: 'post',
    data
  })
}
/**11.发送给客户*/
export function send_to_customer(data) {
  return request({
    url: '/icps/system/sign/settlement/statement/send_to_customer',
    method: 'post',
    data
  })
}
/**12.补差*/
export function generate_tansport_tatement_compensate(data) {
  return request({
    url: '/icps/system/sign/settlement/raw/Compensate/specialMaterialsBalancePayment',
    method: 'post',
    data
  })
}
/**13.修改*/
export function update_statement(data) {
  return request({
    url: '/icps/system/sign/settlement/trans/SpecialMaterials/detail/updateStatement',
    method: 'post',
    data
  })
}
















